export enum DataRoomDrawerVariant {
  Admin = "admin",
  DcrsList = "dcrsList",
}
